export const DEFAULT_LAB_RETAIL_PRICE = 707;
export const DEFAULT_LAB_MEMBER_PRICE = 399;
export const DEFAULT_LAB_DISCOUNT_PERCENT = 43;

const toMoney = (value, fallback) => {
  const n = Number(value);
  if (!Number.isFinite(n) || n < 0) return fallback;
  return Math.round(n * 100) / 100;
};

const toPercent = (value, fallback) => {
  const n = Number(value);
  if (!Number.isFinite(n) || n < 0) return fallback;
  if (n > 100) return 100;
  return Math.round(n * 100) / 100;
};

export const normalizeLabPricing = (payload = {}) => ({
  labRetailPrice: toMoney(payload.labRetailPrice, DEFAULT_LAB_RETAIL_PRICE),
  labMemberPrice: toMoney(payload.labMemberPrice, DEFAULT_LAB_MEMBER_PRICE),
  labDiscountPercent: toPercent(
    payload.labDiscountPercent,
    DEFAULT_LAB_DISCOUNT_PERCENT
  ),
});
